import "amazon-connect-chatjs";
import React, { Fragment, useState, useEffect } from "react";
export default function PnmacLiveChat(props) {
  var isLoaded = connect && connect.ChatSession;
  var _a = useState(props.startChatData || null),
    startChatData = _a[0],
    setStartChatData = _a[1];
  var _b = useState(false),
    connectIsActive = _b[0],
    setConnectIsActive = _b[1];
  var _c = useState(false),
    renewConnection = _c[0],
    setRenewConnection = _c[1];
  var _d = useState(props.liveAgentTimerId || null),
    liveAgentTimerId = _d[0],
    setLiveAgentTimerId = _d[1];
  var connectSession = null;
  var isInitMsgSent = false;
  var currentEventType = null;
  var previousEventType = null;
  var prevAgentName = null;
  useEffect(function () {
    if (props.closeLiveChat) {
      props.closeLiveChat(function () {
        return connectSession.disconnectParticipant();
      });
    }
    if (startChatData) {
      connectToConnect(startChatData);
    } else {
      getStartChatData(connectToConnect);
    }
  }, []);
  function connectToConnect(startParams, retry) {
    if (props.onLiveAgentBusy) {
      props.onLiveAgentBusy(true);
    }
    if (!startParams) {
      if (props.onConnectionFailed) {
        props.onConnectionFailed("Something went wrong fetching connection params");
      }
    }
    try {
      connectSession = connect.ChatSession.create({
        chatDetails: startParams,
        type: connect.ChatSession.SessionTypes.CUSTOMER
      });
    } catch (error) {
      props.onMessageReceived("MSG_CANNOT_CONNECT");
      if (props.onLiveAgentBusy) {
        props.onLiveAgentBusy(false);
      }
      clearConnections();
      // throw error;    
      //if(retry){
      //will implement if needed.
      // }
    }
    if (connectSession && connectSession.controller.contactId == startParams.ContactId) {
      props.onConnectSessionCreated(connectSession);
      var thiSessionPromise = connectSession.connect().then(function (resp) {
        if (resp.connectSuccess) {
          setConnectIsActive(true);
          if (props.onConnectionCreated) {
            props.onConnectionCreated(resp, {
              contactId: connectSession.controller.contactId,
              initialContactId: connectSession.controller.initialContactId,
              connectSession: connectSession
            });
          }
        }
        return Promise.resolve(resp);
      }, function (error) {
        props.onMessageReceived("MSG_CANNOT_CONNECT");
        if (props.onConnectionFailed) {
          props.onConnectionFailed(error);
        }
        clearConnections();
        return Promise.reject(error);
      });
      connectSession.onConnectionEstablished(function (data) {
        console.log("Live agent connetion Established!");
      });
      connectSession.onMessage(function (message) {
        currentEventType = message.data.ContentType;
        var skipOutput = false;
        var cannotConnect = false;
        if (message) {
          var displayName = message.data.DisplayName;
          var msgContent = message.data.Content ? message.data.Content : "Start of conversation";
          if (displayName == "SYSTEM_MESSAGE" || message.data.DisplayName == "BOT") {
            displayName = "Penny";
          }
          message.data.DisplayName = displayName;
          if (previousEventType == "application/vnd.amazonaws.connect.event.transfer.succeeded" && (message.data == "IGNORE_MESSAGE" || currentEventType == "application/vnd.amazonaws.connect.event.participant.left" || currentEventType == "application/vnd.amazonaws.connect.event.chat.ended")) {
            return;
          }
          if (msgContent == "MSG_NoBusinessHours" || msgContent == "MSG_NoAgentsAvailable" || msgContent == "MSG_LongWait" || msgContent == "ERROR_CheckTraffic" || msgContent == "ERROR_LiveAgentFlow" || msgContent == "ERROR_AtCapacity") {
            disconnectParticipant();
            //show message to customer from watson
            message.data = "MSG_CANNOT_CONNECT";
            clearConnections();
          }
          if (msgContent == "ERROR_LiveAgentFlow") {
            message.data = "MSG_SOMETHING_WRONG";
            clearConnections();
          }
          if (msgContent == "MSG_LEXConnectToAgent") {
            message.data = "IGNORE_MESSAGE";
          }
          if (msgContent && msgContent.search("LiveAgent .") == 0 || msgContent.search("LiveAgent ".concat(props.loanId)) == 0) {
            message.data = "IGNORE_MESSAGE";
            skipOutput = true;
          }
          var timerId = null;
          if (msgContent == "MSG_StartTimer") {
            var timeoutSeconds = props.liveAgentConnTimeOut || 60;
            timerId = setTimeout(function () {
              disconnectParticipant();
              message.data = "MSG_CANNOT_CONNECT";
              clearConnections(timerId);
              setStartChatData(null);
              if (props.cleanupLiveAgentSession) {
                props.cleanupLiveAgentSession();
              }
              var content = {
                ContentType: "application/vnd.amazonaws.connect.event.chat.ended",
                Content: "AGENT_COULD_NOT_RESPOND"
              };
              props.onMessageReceived(content, {
                contactId: connectSession.controller.contactId,
                initialContactId: connectSession.controller.initialContactId
              });
            }, timeoutSeconds * 1000);
            setLiveAgentTimerId(timerId);
            message.data = "IGNORE_MESSAGE";
          }
          if (msgContent == "MSG_SuccessConnect") {
            if (!isInitMsgSent) {
              try {
                var lexMessage = "liveagent ".concat(props.loanId, " ").concat(props.last4);
                if (props.idsUserId) {
                  lexMessage = "".concat(lexMessage, " ").concat(props.idsUserId);
                }
                if (props.MSRId) {
                  lexMessage = "".concat(lexMessage, " ").concat(props.MSRId, " ");
                }
                connectSession.controller.sendMessage({
                  message: lexMessage,
                  contentType: "text/plain"
                });
                isInitMsgSent = true;
                //disconnectParticipant();
              } catch (err) {
                console.log("init error", err);
                //localStorage.removeItem("startChatData");
                message.data = "MSG_SOMETHING_WRONG";
                clearConnections();
              }
            }
            skipOutput = true;
          } else if (msgContent == "Start of conversation") {
            //tell the customer we are ready.
            // if(props.getHistoryToAgentForContext){
            //   setTimeout(() => {
            //     var message = props.getHistoryToAgentForContext();
            //   connectSession.controller.sendMessage({
            //     message: message,
            //     contentType: "text/plain",
            //   });
            //   }, 100);                  
            // }
            //console.log("can chat now");
          }
          previousEventType = currentEventType;
          if (message.data.ContentType == "application/vnd.amazonaws.connect.event.participant.left" || message.data.ContentType == "application/vnd.amazonaws.connect.event.chat.ended") {
            if (liveAgentTimerId) clearTimeout(liveAgentTimerId);
            disconnectParticipant();
            clearConnections();
          } else if (message.data.ContentType == "application/vnd.amazonaws.connect.event.participant.joined") {
            clearTimeout(liveAgentTimerId);
          }
          if (props.onMessageReceived && !skipOutput) {
            if (props.onAgentTyping) {
              props.onAgentTyping(false);
            }
            props.onMessageReceived(message.data, {
              contactId: connectSession.controller.contactId,
              initialContactId: connectSession.controller.initialContactId,
              liveAgentTimerId: timerId
            });
          }
        }
      });
      connectSession.onTyping(function (typingEvent) {
        if (props.onAgentTyping) {
          props.onAgentTyping(typingEvent);
        }
      });
      connectSession.onConnectionBroken(function (data) {
        setConnectIsActive(false);
        if (props.onConnectionDropped) {
          props.onConnectionDropped(data);
        }
      });
    }
  }
  function disconnectParticipant() {
    if (connectSession && connectSession.controller && connectSession.controller.connectionHelper && connectSession.controller.connectionHelper.status != null && connectSession.controller.connectionHelper.status != "Ended") {
      connectSession.controller.disconnectParticipant();
    } else if (connectSession && connectSession.controller) {
      connectSession.controller.disconnectParticipant();
    }
  }
  function getStartChatData(callback) {
    if (props.onLiveAgentBusy) {
      props.onLiveAgentBusy(true);
    }
    if (!props.getStartChatData) {
      props.onMessageReceived("MSG_CANNOT_CONNECT", {
        contactId: null,
        initialContactId: null
      });
    }
    var params = props.getStartChatData();
    params.then(function (data) {
      if (data) {
        setStartChatData(data);
        if (callback) {
          callback(data);
        }
      }
    }).catch(function (error) {
      console.error(error);
      props.onMessageReceived("MSG_CANNOT_CONNECT", {
        contactId: null,
        initialContactId: null
      });
    });
    // if (callback) {
    //   callback(params);
    // }
  }
  function sendMessage(msg) {
    if (!connectSession || connectSession.controller) {
      //failed to send message to live agent;
    }
    if (connectSession && connectSession.controller) {
      connectSession.controller.sendMessage({
        message: msg,
        contentType: "text/plain"
      });
    }
  }
  function clearConnections(timerId) {
    if (props.onLiveAgentBusy) {
      props.onLiveAgentBusy(false);
    }
    if (liveAgentTimerId) {
      clearTimeout(liveAgentTimerId);
    } else if (timerId) {
      clearTimeout(timerId);
    } else if (props.liveAgentTimerId) {
      clearTimeout(props.liveAgentTimerId);
    }
    setStartChatData(null);
    setConnectIsActive(false);
    // setRenewConnection(true);
    if (props.cleanupLiveAgentSession) {
      props.cleanupLiveAgentSession();
    }
  }
  return /*#__PURE__*/React.createElement(Fragment, null);
}